export const COMPANY_READONLY = [
  ["Domain_Name", "Domain"],
  ["Status", "Status"],
];

export const COMPANY_DETAILS_READONLY = [
  ["Company_Name", "Company name"],
  ["Company_Email", "Company email"],
  ["Company_Phone", "Company phone"],
];

export const COMPANY_EDITABLE = [
  ["Website", "Website"],
  ["Website_Domain_Name", "Website domain name"],
];

export const COMPANY_ADDRESS_EDITABLE = [
  ["Address_Line_1", "Address line 1"],
  ["Address_Line_2", "Address line 2"],
  ["Zip_Code", "Zip code"],
];

export const COMPANY_ADDRESS = [
  ...COMPANY_ADDRESS_EDITABLE.slice(0, 2),
  ["Country_Name", "Country"],
  ["State_Name", "State"],
  ["City_Name", "City"],
  ...COMPANY_ADDRESS_EDITABLE.slice(2),
];

export function displayCompanyValue(value) {
  if (value == null || String(value).trim() === "") return "—";
  return String(value);
}
